import { greetingFor, formatBytes } from './format.js';

export const el = (id) => document.getElementById(id);

/** A fresh copy of a `<template>`'s single root element, ready to fill in and append. */
export const clone = (id) => document.getElementById(id).content.firstElementChild.cloneNode(true);

export function showLogin() {
  el('login-view').hidden = false;
  el('app-view').hidden = true;
}

export function showApp() {
  el('login-view').hidden = true;
  el('app-view').hidden = false;
  el('greeting').textContent = greetingFor(new Date());
  showHome();
}

const VIEWS = ['home', 'note', 'calendar', 'class', 'study', 'notepage'];

/**
 * Exactly one content view is ever visible. `navKey` is what the sidebar
 * highlights, which is not always the view name: studying a set keeps its
 * class lit, because that is where Back goes.
 */
export function showView(name, navKey = name) {
  for (const view of VIEWS) el(`${view}-view`).hidden = view !== name;
  for (const row of document.querySelectorAll('#side-nav .nav-row')) {
    row.classList.toggle('is-on', row.dataset.nav === navKey);
  }
}

export function showHome() {
  showView('home');
}

export function showNote() {
  showView('note');
  el('note-text').focus();
}

export function showLoginError(message) {
  const node = el('login-error');
  node.textContent = message;
  node.hidden = !message;
}

export function setStatus(message, kind) {
  const node = el('upload-status');
  node.textContent = message;
  node.className = kind ? `status is-${kind}` : 'status';
  node.hidden = !message;
}

export function setProgress(percent) {
  el('upload-progress').hidden = percent === null;
  if (percent !== null) el('upload-progress-bar').style.width = `${percent}%`;
}

/**
 * Built with createElement and textContent rather than innerHTML: a filename
 * is untrusted input and must never be parsed as markup.
 */
export function addCapture(file) {
  el('captures-empty').hidden = true;

  const li = document.createElement('li');
  li.className = 'capture';

  const kind = document.createElement('div');
  kind.className = 'capture-kind';
  kind.textContent = 'REC';

  const body = document.createElement('div');
  const title = document.createElement('div');
  title.className = 'capture-title';
  title.textContent = file.name;
  const meta = document.createElement('div');
  meta.className = 'capture-meta';
  meta.textContent = `${formatBytes(file.size)} · uploaded just now`;
  body.append(title, meta);

  li.append(kind, body);
  el('captures-list').prepend(li);
}
